<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTES DE ATENCIONES</h5>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <td colspan="4">
                <button class="btn btn-success mx-1" type="button" @click="imprime()">
                  <i class="fa fa-file-pdf-o"></i>
                </button>
                <button class="btn btn-success mx-1" type="button" @click="imprimexel()">
                  <i class="fa fa-file-excel-o"></i>
                </button>

                <button class="btn btn-info mx-2" type="button" @click="obtenerReportes()">
                  Buscar
                  <i class="fa fa-search"></i>
                </button>
              </td>
            </tr>
            <tr>
              <th colspan="2">
                <select
                    class="custom-select"
                    v-model="seleccionado"
                    @change="getConfigEmpresa()"
                >
                  <option value="">SELECCIONAR EMPRESA</option>
                  <option
                      v-for="(t, i) in vempresas"
                      :value="t.id_empresa"
                      :key="t.nombre_empresa + i"
                  >{{ t.nombre_empresa }}
                  </option
                  >
                </select>
                <select
                    class="custom-select"
                    v-model="vueloselec"
                >
                  <option value="null">SELECCIONAR VUELO</option>
                  <option
                      v-for="(t, i) in confempresa"
                      :value="t.id_config_empresa"
                      :key="i"
                  >{{ t.nro_vuelo }}
                  </option
                  >
                </select>
              </th>
              <th colspan="2">
                <select
                    class="custom-select"
                    v-model="selectRobot"

                >
                  <option value="null">SELECCIONAR EQUIPO</option>
                  <option
                      v-for="(t, i) in rbt_robotList"
                      :value="t.nombre"
                      :key="i"

                  >{{ t.nombre }}
                  </option>

                </select>
              </th>
            </tr>
            <tr>
              <th colspan="2">
                <b-row>
                  <b-col sm="8">
                    <b-form-datepicker
                        id="fecha-inicial"
                        placeholder="Seleccione fecha inicio"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="fecha_ini"
                    >
                    </b-form-datepicker>
                  </b-col>
                  <!--@input="fechaInicial"-->
                  <b-col sm="4">
                    <b-form-timepicker
                        placeholder="Hora"
                          id="ex-disabled-readonly"
                          v-model="hora_ini"
                    >
                    </b-form-timepicker>
                  </b-col>
                </b-row>
              </th>
              <th colspan="2">
                <b-row>
                  <b-col sm="8">
                <b-form-datepicker
                    id="fecha-final"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    placeholder="Seleccione fecha fin"
                    v-model="fecha_fin"

                    locale="es">
                </b-form-datepicker>
                    <!--@input="fechaFinal"-->
                  </b-col>
                  <b-col sm="4">
                    <b-form-timepicker
                        v-model="hora_fin"
                        id="ex-disabled-readonly"
                        placeholder="Hora"
                    ></b-form-timepicker>
                  </b-col>
                </b-row>
              </th>
            </tr>
            </thead>
            <tbody v-for="(itemes, index) in incidenciasgen" :key="index+20">

            <tr>
              <td colspan="10"><h1>{{itemes.nombre}}</h1></td>
            </tr>
            <tr class="text-center">
              <th><small class="font-weight-bold">EQUIPO</small></th>
              <th><small class="font-weight-bold">FECHA</small></th>
              <th><small class="font-weight-bold">EMPRESA/VUELO</small></th>
              <th><small class="font-weight-bold">ATENDIDOS</small></th>
            </tr>
            <tr v-for="(item, index) in itemes.data" :key="index">
              <td>
                <small>{{ item.rbt_nombre }}</small>
              </td>
              <td class="text-center">
                <small> {{ new moment(item.rbt_fecha).format("DD/MM/YYYY") }}</small>
              </td>
              <td class="text-center">
                {{ item.rbt_empresa }}
              </td>
              <td class="text-center">
                {{ item.rbt_cantidad }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="cargando"/>
  </div>
</template>
<script>
import Loading from "../../components/Loading";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado: '',
      seleccionadoerr1: '',
      seleccionadoerr2: '',
      seleccionadoerr3: '',
      seleccionadoerr4: '',
      seleccionadoerr5: '',
      vueloselec: null,
      fields: [],
      vempresas: [],
      confempresa: [],
      dataenv: {},
      perPage: 3,
      hora_ini:'00:00:00',
      hora_fin:'23:59:59',
      currentPage: 1,
      registrosEncontrados: [],
      parametro: '',
      incidenciasgenNew: [],
      incidenciasgen: [],
      incidenciasdet: [],
      observacion: {
        descripcion: '',
        vuelo: '',
        fecha: '28/01/16'
      },
      observaciones: [],
      cargando: false,
      erroresUno: [],
      erroresDos: [],
      erroresTres: [],
      erroresCuatro: [],
      erroresCinco: [],
      fecha_ini: null,
      fecha_fin: null,
      rbt_robotList: [],
      selectRobot: null,
      rbt_id_config_flujo: null,
      rbt_robot: null,
      value: '',
      context: null
    };
  },
  methods: {

    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/getEmpresaVuelo`);
        this.vempresas = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
    
        let resultados = await this.axios.get(`/getConfigempresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
         
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerIncidenciasDetalle(id) {
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}`);
        this.incidenciasdet = resultados.data.contenido;
        //console.log(this.incidenciasdet);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async obtenerErrores() {
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno = resultados.data.contenido;
    },
    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item) {
      item.observacion_equipo = "";
    },
    crearReporte() {
      this.$router.push('crearReporte');
    },
    async obtenerReportes() {
      this.rbt_id_config_flujo = this.vueloselec;
      this.rbt_robot = this.selectRobot;
      try {
        let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
        let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
        let resultados = await this.axios.get(`/reporte-robot/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}/${this.rbt_id_config_flujo}`);
        this.busquedaExtranjeroSicof(this.fecha_ini, this.fecha_fin);
        this.incidenciasgenNew = resultados.data.contenido;
        this.incidenciasgen = this.incidenciasgenNew;
    
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
          new Blob([response.data], {type: "blob"})
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    async imprime() {
      this.rbt_id_config_flujo = this.vueloselec;
      this.rbt_robot = this.selectRobot;
      let config = {headers: {token: this.token}, responseType: "blob"};

      try {
        let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
        let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
        let resultados = await this.axios.get(`/reporte_robot/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}/${this.rbt_id_config_flujo}`, config);
        await this.crearDescarga(resultados, "reporte.pdf");
      } catch (error) {
        console.log(error);
      }
    },
    async imprimexel() {
      this.rbt_id_config_flujo = this.vueloselec;
      this.rbt_robot = this.selectRobot;
      let config = {headers: {token: this.token}, responseType: "blob"};

      try {
        let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
        let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
        let resultados = await this.axios.get(`/reporte_robotxls/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}/${this.rbt_id_config_flujo}`, config);
        await this.crearDescarga(resultados, 'reporte.xlsx');
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerRobots() {
      let resultados = await this.axios.get(`/robots`);
      this.rbt_robotList = resultados.data.contenido;
    },
    async busquedaExtranjeroSicof(rbt_fechaini, rbt_fechafin) {
      if (rbt_fechaini == null || rbt_fechaini == '' || rbt_fechaini == 'null') {
        rbt_fechaini = "1900-01-01";
      }
      if (rbt_fechafin == null || rbt_fechafin == '' || rbt_fechafin == 'null') {
        rbt_fechafin = "1900-01-01";
      }
      try {
        let resultados = await this.axios.get(
            `/ReporteVuelosFecha/${rbt_fechaini}/${rbt_fechafin}`
        );
        this.registrosEncontrados = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
        this.$swal({
          title: "Información",
          text: "Ocurrio un Error al realizar la consulta!",
          type: "error",
          confirmButtonText: "Aceptar",
        });
      }
    },
  },
  created() {
    this.obtenerErrores();
    this.getNombreEmpresas();
    this.obtenerReportes();
    this.obtenerRobots();
    this.busquedaExtranjeroSicof();
  }
};
</script>
